import React from 'react';

const RangeInput = (props) => (
  <input type="range" data-name="RangeInput" style={{ height: props.height ? props.height : 'unset' }} {...props} />
);

export default RangeInput;
